import { AlertCircle, AlertTriangle, CheckCircle, Info } from 'lucide-react';
import React, { ReactNode } from 'react';

import { Alert, AlertDescription, AlertTitle } from '@/design-system/components/ui';

export type CalloutType = 'info' | 'success' | 'warning' | 'error';

interface IProps {
  title: ReactNode;
  body?: ReactNode;
  type: CalloutType;
  action?: ReactNode;
  className?: string;
  filled?: boolean;
}

const iconMap: Record<CalloutType, React.ReactNode> = {
  info: <Info size={20} />,
  success: <CheckCircle size={20} />,
  warning: <AlertTriangle size={20} />,
  error: <AlertCircle size={20} />,
};

export const Callout: React.FC<IProps> = ({ title, body, type, action, className, filled: _filled }) => {
  return (
    <Alert variant={type} icon={iconMap[type]} className={className}>
      <div className="tw:flex tw:justify-between tw:items-start tw:w-full">
        <div>
          <AlertTitle>{title}</AlertTitle>
          {body && <AlertDescription>{body}</AlertDescription>}
        </div>
        {action && <div className="tw:shrink-0 tw:ml-2">{action}</div>}
      </div>
    </Alert>
  );
};
